'use client';

import { useState } from 'react';
import { useIntl } from 'react-intl';

import { Image } from '@packages/shared/src/ui/Image/Image';
import { SustainabilityModalDynamic } from './SustainabilityModal.dynamic';
import { messages } from './SustainabilityIcon.messages';

export type SustainabilityIconProps = {
  iconUrl: string;
  value: string;
  onClick?: () => void;
  modalContent?: React.ReactNode;
};

/**
 * Renders a sustainability icon button that opens a dialog with additional information when clicked.
 */

export const SustainabilityIcon = ({
  iconUrl,
  value,
  onClick,
  modalContent,
}: SustainabilityIconProps) => {
  const { formatMessage } = useIntl();
  const [isModalOpen, setIsModalOpen] = useState<boolean>(false);

  const openDialogHandler = () => {
    setIsModalOpen(true);
  };

  const closeDialogHandler = () => {
    setIsModalOpen(false);
  };

  const onClickHandler = () => {
    if (value) {
      openDialogHandler();
    }
    if (onClick) {
      onClick();
    }
  };

  return (
    <>
      <button
        type="button"
        className="flex w-full max-w-4 items-center gap-1.5 text-left"
        onClick={onClickHandler}
        disabled={!value}
      >
        {iconUrl && (
          <Image
            width={32}
            height={32}
            alt={formatMessage(messages.sustainabilityIconImageAlt)}
            src={iconUrl}
            unoptimized
            className="max-h-6.5 max-w-6.5 object-contain"
          />
        )}
      </button>
      {value && isModalOpen && (
        <SustainabilityModalDynamic isModalOpen={isModalOpen} onClose={closeDialogHandler}>
          {modalContent}
        </SustainabilityModalDynamic>
      )}
    </>
  );
};
